export const FETCH_PUBLISHED_TEMPLATE_NAME_BY_ID_REQUEST = 'FETCH_PUBLISHED_TEMPLATE_NAME_BY_ID_REQUEST'
export const FETCH_PUBLISHED_TEMPLATE_NAME_BY_ID_SUCCESS = 'FETCH_PUBLISHED_TEMPLATE_NAME_BY_ID_SUCCESS'
export const FETCH_PUBLISHED_TEMPLATE_NAME_BY_ID_FALUIRE = 'FETCH_PUBLISHED_TEMPLATE_NAME_BY_ID_FALUIRE'
